import script from "./StatisticsRetained.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsRetained.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsRetained.vue?vue&type=style&index=0&id=b91938b2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91938b2"]])

export default __exports__